import { render } from "./ResumenAdminPaneles.vue?vue&type=template&id=50530e2e&scoped=true"
import script from "./ResumenAdminPaneles.vue?vue&type=script&lang=js"
export * from "./ResumenAdminPaneles.vue?vue&type=script&lang=js"

import "./ResumenAdminPaneles.vue?vue&type=style&index=0&id=50530e2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50530e2e"]])

export default __exports__